import classes from './ChatWidget.module.scss'
import ResultCard from './ResultCard'
import { displayValue, formatChatDate } from './chatFormatters'
import { SerialNumberCheck } from './types'

interface Props {
  checks: SerialNumberCheck[]
}

/**
 * Seri no kontrol sonuçlarının sohbet balonu gösterimi: kayıt başına bir kart.
 * Modal, geniş olduğu için tabloyu korur; balon en fazla ~600px olduğundan aynı tablo
 * yatay kaydırmaya düşerdi.
 */
export default function SerialNumberCheckCards({ checks }: Props) {
  if (checks.length === 0) return null

  return (
    <div className={classes.resultCardList}>
      {checks.map((check, index) => (
        <ResultCard
          key={`${check.serialNumber || 'seri'}-${check.invoiceNumber || index}-${index}`}
          eyebrow={`Seri no ${displayValue(check.serialNumber)}`}
          title={displayValue(check.productName)}
          subtitle={displayValue(check.productCode)}
          items={[
            { label: 'Marka', value: displayValue(check.brand) },
            { label: 'Kategori', value: displayValue(check.category) },
            { label: 'Fatura no', value: displayValue(check.invoiceNumber) },
            { label: 'E-fatura no', value: displayValue(check.eInvoiceNumber) },
            { label: 'Fatura tarihi', value: formatChatDate(check.invoiceDate) },
            { label: 'Teslimat no', value: displayValue(check.deliveryNumber) },
            { label: 'Teslimat tarihi', value: formatChatDate(check.deliveryCreationDate) },
          ]}
        />
      ))}
    </div>
  )
}
